<template>
	<div class="half_1_2">
		<div class="white-block wg_1">
			<div class="patient-info-title wg_title">
				<div class="sched_plus" @click="showForms('consultation')" v-if="isCanWrite"></div>
				<p>Консультации</p>
			</div>
			<div class="patient-form cont_wg">
				<div class="patient-form-block pat_wg_box" v-for="item in consultations">
					<div class="formButton list" @click="selectRecord(item)">
						{{item.formName}}
					</div>
				</div>

				<div class="no_records_wg" v-if="!consultations.length">
					Еще не было добавлено записей в эту категорию
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'Consultation',
		computed: {
			userId() {
				return this.$route.query.patient
			},
			workerId() {
				return this.$route.query.doctor
			},
			isCanWrite() {
				return this.$parent.isCanWrite
			}
		},
		mounted(){
			this.$event.connect('consultation', () => {
				this.getConsultations()
			})
			this.getConsultations()
		},
		data() {
			return {
				consultations: [],
				showForms: this.$parent.showForms,
				selectRecord: this.$parent.selectRecord
			}
		},
		methods: {
			getConsultations() {
				this.$store.dispatch('card/getByType', {
					type: "consultation",
					worker_id: this.workerId,
					user_id: this.userId
				}).then(response => this.consultations = response)
			}
		}
	}
</script>
<style>

	.formButton {
		transition: background 100ms linear;
		padding: 5px 3px;
	}

	.formButton:hover {
		background: #13b6bb;
		padding: 5px 3px;
		cursor: pointer;
		transition: background 100ms linear;
	}
</style>



// WEBPACK FOOTER //
// Consultation.vue?458bb104